module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/foggia.ba98948ca4beba368d3603963e86829d.jpg";